import React from "react";

function UniversityOfficialBanner({ className = "h-10 w-10" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 134 134"
      className={className}
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1={-293.22}
          x2={-159.46}
          y1={-158.84}
          y2={-158.84}
          gradientTransform="rotate(-75.18 66.996 -236.446)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#d27d28" />
          <stop offset={0.42} stopColor="#e8a423" />
          <stop offset={0.54} stopColor="#ecb449" stopOpacity={0.82} />
          <stop offset={0.79} stopColor="#f6dcaa" stopOpacity={0.38} />
          <stop offset={1} stopColor="#fff" stopOpacity={0} />
        </linearGradient>
        <style>{".cls-2{stroke-width:0;fill:#fff}"}</style>
      </defs>
      <path
        d="M131.65 84.1c-9.43 35.65-46.1 56.98-81.75 47.55S-7.08 85.55 2.35 49.9 48.45-7.08 84.1 2.35s56.98 46.1 47.55 81.75ZM23.38 55.46c-6.36 24.05 8.03 48.8 32.08 55.16 24.05 6.36 48.8-8.03 55.16-32.08s-8.03-48.8-32.08-55.16c-24.05-6.36-48.8 8.03-55.16 32.08Z"
        style={{
          strokeWidth: 0,
          fill: "url(#linear-gradient)",
        }}
      />
      <path
        d="m81.12 119.88-1.22.25.04 1.05 1.22-.25.05 1.13-1.23.25.07 1.84-1.13.23-.07-1.84-1.16.24.07 1.84-1.13.23-.07-1.84-1.22.25-.05-1.13 1.23-.25-.04-1.05-1.25.26-.05-1.14 1.25-.26-.07-1.82 1.13-.23.07 1.82 1.16-.24-.07-1.83 1.13-.23.07 1.83 1.21-.25.05 1.14Zm-2.31 1.53-.04-1.05-1.16.24.04 1.05 1.16-.24ZM86.74 122.95c-.84.3-1.62.3-2.33.02-.71-.29-1.21-.83-1.49-1.63l-1.8-5.09 1.48-.52 1.76 4.97c.14.4.37.67.67.82.31.15.71.14 1.19-.03s.8-.41.94-.72c.14-.31.15-.67 0-1.06l-1.76-4.97 1.49-.53 1.8 5.09c.28.8.24 1.53-.13 2.2-.37.67-.98 1.15-1.83 1.45ZM91.96 111.66l1.41-.73 3.71 7.12-1.07.56-5.32-2.76 2.27 4.35-1.4.73-3.71-7.12 1.07-.56 5.31 2.75-2.26-4.34ZM94.34 110.22l1.33-.87 4.39 6.72-1.32.87-4.4-6.72ZM108.56 107.74c-.05 1.14-.5 2.11-1.36 2.89-.86.79-1.85 1.16-2.99 1.11-1.14-.05-2.11-.5-2.9-1.36-.79-.86-1.16-1.86-1.12-3 .05-1.14.5-2.1 1.35-2.89.86-.79 1.86-1.16 3-1.11 1.14.04 2.11.5 2.9 1.36.79.86 1.16 1.86 1.11 3.01Zm-4.27 2.46c.7.03 1.32-.21 1.86-.71s.83-1.09.86-1.79c.03-.7-.21-1.33-.73-1.89-.52-.56-1.13-.86-1.83-.89-.7-.03-1.32.2-1.87.7-.54.5-.83 1.1-.85 1.8-.03.7.21 1.33.73 1.9.52.56 1.13.86 1.83.88ZM109.36 98.41l-2.04 2.48 1.47 1.21 1.98-2.41 1.17.96-1.98 2.41 2.39 1.97-1 1.22-6.2-5.1 3.04-3.7 1.17.96ZM112.54 93.59l-1.75 2.69 1.59 1.04 1.7-2.61 1.27.83-1.7 2.61 2.59 1.69-.86 1.33-6.73-4.38 2.62-4.02 1.27.83ZM111.68 91.93l.75-1.39 7.07 3.8-.75 1.39-7.07-3.8ZM122.08 89.09c-.46 1.12-1.21 1.89-2.25 2.32s-2.11.42-3.2-.03c-1.1-.45-1.87-1.19-2.31-2.22-.44-1.03-.44-2.11.02-3.22.27-.67.68-1.23 1.23-1.67s1.15-.71 1.82-.81l.22 1.56c-.41.05-.78.21-1.1.47-.33.26-.58.61-.75 1.03-.29.72-.31 1.4-.03 2.02s.77 1.09 1.49 1.38c.71.29 1.39.31 2.02.05.63-.26 1.1-.75 1.39-1.47.17-.42.24-.85.19-1.27-.05-.42-.2-.79-.45-1.09l1.25-.96c.41.54.65 1.15.74 1.85.08.7-.01 1.38-.29 2.06ZM115.87 82.11l.44-1.52 7.71 2.24-.44 1.52-7.71-2.24ZM125.56 75.76l-1.52.23-.61 3.24 1.33.74-.32 1.68-7.37-4.25.36-1.93 8.42-1.3-.3 1.58Zm-3.48 2.7.42-2.22-3.44.53 3.02 1.69ZM124.52 71.08l.2-3.06 1.51.1-.3 4.64-8.01-.52.1-1.58 6.5.42Z"
        className="cls-2"
      />
    </svg>
  );
}

export default UniversityOfficialBanner;
